<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        radar: {
          indicator: [
            { name: "A", max: 100 },
            { name: "B", max: 100 },
            { name: "C", max: 100 },
            { name: "D", max: 100 }
          ]
        },
        series: [
          {
            type: "radar",
            data: [
              {
                value: [70, 50, 80, 60],
                name: "Data 1"
              }
            ]
          }
        ]
      }
    };
  }
};
</script>
